
import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { newsItems } from '../data/newsData';
import './NewsPage.css';

const NewsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // Find the news item by ID
  const newsItem = newsItems.find(item => item.id === parseInt(id));
  
  // If no news item found, redirect to news list or show error
  if (!newsItem) {
    return (
      <div className="news-page">
        <div className="container">
          <div className="news-not-found">
            <h2>News Article Not Found</h2>
            <p>The requested news article could not be found.</p>
            <Link to="/" className="btn btn-primary">Go Home</Link>
          </div>
        </div>
      </div>
    );
  }
  
  // Format the full content for display
  const formatContent = (content) => {
    return content.split('\n').map((line, index) => {
      // Handle headers
      if (line.startsWith('## ')) {
        return <h2 key={index} className="content-h2">{line.replace('## ', '')}</h2>;
      }
      if (line.startsWith('### ')) {
        return <h3 key={index} className="content-h3">{line.replace('### ', '')}</h3>;
      }
      if (line.startsWith('#### ')) {
        return <h4 key={index} className="content-h4">{line.replace('#### ', '')}</h4>;
      }
      
      // Handle bold text
      if (line.includes('**')) {
        const parts = line.split('**');
        return (
          <p key={index} className="content-paragraph">
            {parts.map((part, i) => 
              i % 2 === 1 ? <strong key={i}>{part}</strong> : part
            )}
          </p>
        );
      }
      
      // Handle bullet points
      if (line.startsWith('- ')) {
        return <li key={index} className="content-list-item">{line.replace('- ', '')}</li>;
      }
      
      // Handle numbered lists
      if (/^\d+\./.test(line)) {
        return <li key={index} className="content-list-item">{line}</li>;
      }
      
      // Handle empty lines
      if (line.trim() === '') {
        return <br key={index} />;
      }
      
      // Handle italic text
      if (line.startsWith('*') && line.endsWith('*')) {
        return <p key={index} className="content-italic">{line.slice(1, -1)}</p>;
      }
      
      // Regular paragraphs
      return <p key={index} className="content-paragraph">{line}</p>;
    });
  };

  return (
    <div className="news-page">
      <div className="container">
        {/* Breadcrumb */}
        <nav className="breadcrumb">
          <Link to="/">Home</Link>
          <span className="separator">/</span>
          <Link to="/">News</Link>
          <span className="separator">/</span>
          <span className="current">{newsItem.title}</span>
        </nav>

        {/* Back Button */}
        <div className="back-section">
          <button 
            className="back-btn"
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left"></i>
            Back to News
          </button>
        </div>

        {/* News Article */}
        <article className="news-article">
          {/* Header */}
          <header className="article-header">
            <div className="article-meta">
              <span className="category">{newsItem.category}</span>
              <span className="read-time">{newsItem.readTime}</span>
            </div>
            <h1 className="article-title">{newsItem.title}</h1>
            <div className="article-info">
              <div className="author-info">
                <i className="fas fa-user"></i>
                <span>By {newsItem.author}</span>
              </div>
              <div className="date-info">
                <i className="fas fa-calendar"></i>
                <span>{new Date(newsItem.date).toLocaleDateString('en-US', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}</span>
              </div>
            </div>
          </header>

          {/* Featured Image Placeholder */}
          <div className="article-image">
            <i className="fas fa-newspaper"></i>
          </div>

          {/* Article Content */}
          <div className="article-content">
            {formatContent(newsItem.fullContent)}
          </div>

          {/* Article Footer */}
          <footer className="article-footer">
            <div className="tags">
              <span className="tag">{newsItem.category}</span>
            </div>
            
            <div className="share-section">
              <h4>Share this article:</h4>
              <div className="share-buttons">
                <button className="share-btn facebook">
                  <i className="fab fa-facebook-f"></i>
                </button>
                <button className="share-btn twitter">
                  <i className="fab fa-twitter"></i>
                </button>
                <button className="share-btn linkedin">
                  <i className="fab fa-linkedin-in"></i>
                </button>
                <button className="share-btn whatsapp">
                  <i className="fab fa-whatsapp"></i>
                </button>
              </div>
            </div>
          </footer>
        </article>

        {/* Related Articles */}
        {/* <section className="related-articles">
          <h3>Related Articles</h3>
          <div className="related-grid">
            {newsItems
              .filter(item => item.id !== newsItem.id && item.category === newsItem.category)
              .slice(0, 3)
              .map(relatedItem => (
                <div key={relatedItem.id} className="related-card">
                  <Link to={`/news/${relatedItem.id}`}>
                    <div className="related-image">
                      <i className="fas fa-newspaper"></i>
                    </div>
                    <div className="related-content">
                      <h4>{relatedItem.title}</h4>
                      <p>{relatedItem.excerpt}</p>
                      <span className="related-date">{relatedItem.date}</span>
                    </div>
                  </Link>
                </div>
              ))}
          </div>
        </section> */}
      </div>
    </div>
  );
};

export default NewsPage;
